import React, { useEffect, useState } from "react";
import "../../modal.css";

export default function TravelMultiplePlanSelection({ openModal, handleSearch, planList, inputStatus, selectedPlanIds, SelectPlan, handleSubmit }) {
  return (
    <div id="popup1" className={`overlay  ${openModal}`}>
      <div className="chatpopup">
        <div className="select-plans-section with-search">

          <form action="">
            <input type="search" placeholder="Search plans" onChange={(event) => handleSearch(event.target.value)} className="search-input" />
          </form>
          <div className="heading">Please select two plans</div>
          <div className="plan-comparison-list" >
            {/* <ViewPlanList planList={planList} selectedPlanId={selectedPlanId} inputStatus={inputStatus} SelectPlan={SelectPlan} /> */}
            {
              planList ? planList.map((item) =>
                <div className={`plan ${inputStatus(item.plan_id)}`} key={item.plan_id}>
                  <label className="plan-details">
                    <input disabled={!selectedPlanIds.includes(item.plan_id) && selectedPlanIds.length >= 2} checked={selectedPlanIds.includes(item.plan_id)} type="checkbox" onChange={(event) => SelectPlan(item, event.target.checked)} />
                    <span className="checkmark"></span>
                    <div className="name-img">
                      <img src={item.ImageUrl} alt="" />
                      <div className="name">{item.plan_name}</div>
                    </div>
                  </label>
                </div>
              ) : null}
          </div>
          <button type="button" className="button" disabled={selectedPlanIds.length != 2} onClick={() => handleSubmit()}>Compare plans</button>
        </div>
      </div>
    </div>
  );
}
